import { useCallback } from 'react'

import { useUpdateAssetForCopyMutation } from '~generated/hooks'
import { UpdateAssetInput } from '~generated/types'

/* eslint-disable import/prefer-default-export */
export function useUpdateAssetForCopy() {
  const [updateAssetForCopyMutation, options] = useUpdateAssetForCopyMutation()

  const handleUpdate = useCallback(
    async (input: UpdateAssetInput) => {
      const data = await updateAssetForCopyMutation({
        variables: { input },
      })
      return data
    },
    [updateAssetForCopyMutation]
  )

  return [handleUpdate, options.loading] as const
}
